import { render, staticRenderFns } from "./QuotationSecondStepResource.vue?vue&type=template&id=40a824e5"
import script from "./QuotationSecondStepResource.vue?vue&type=script&lang=js"
export * from "./QuotationSecondStepResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports